export const heroKicker = "吃瓜群众速来围观";

export const heroTags = ["热帖排行", "热门瓜", "火爆帖", "吃瓜现场"];

export const statsData = [
  { value: "12,486", label: "今日新增热帖", icon: "ri-file-list-3-line" },
  { value: "38.2万", label: "围观人次", icon: "ri-eye-line" },
  { value: "4,209", label: "热评互动", icon: "ri-chat-3-line" },
  { value: "27", label: "进行中话题", icon: "ri-fire-line" },
];

export const featureTopic = {
  badge: "本周封面话题",
  title: "综艺路透连环爆料，吃瓜节奏被彻底带飞",
  summary:
    "从录制现场流出的片段到嘉宾阵容的细微变化，本周话题几乎每天都在更新。热度攀升的不只是讨论量，还有各路吃瓜群众的推理热情。",
  points: [
    "话题单日讨论量上涨 186%",
    "相关热帖连续 3 天霸榜前三",
    "评论区出现多角度现场还原",
  ],
};

export type HotPost = {
  rank: number;
  title: string;
  summary: string;
  tag: string;
  heat: string;
  comments: string;
  fresh?: boolean;
};

export const hotPosts: HotPost[] = [
  {
    rank: 1,
    title: "某顶流演唱会临时调整歌单，现场观众反应两极",
    summary: "开场前一小时歌单被替换，返场曲目意外加码，观众在评论区各执一词。",
    tag: "现场速报",
    heat: "98.6万",
    comments: "3,214",
    fresh: true,
  },
  {
    rank: 2,
    title: "都市剧杀青宴画面流出，主创同框细节被反复解读",
    summary: "一张合影里的人物站位成了讨论焦点，粉丝逐帧分析现场氛围。",
    tag: "热帖追踪",
    heat: "86.4万",
    comments: "2,876",
    fresh: true,
  },
  {
    rank: 3,
    title: "综艺新赛制路透曝光，常驻阵容疑似迎来大换血",
    summary: "有现场观众称录制顺序被重新排列，节目组暂未作出任何回应。",
    tag: "阵容风向",
    heat: "79.1万",
    comments: "2,530",
  },
  {
    rank: 4,
    title: "音乐节压轴时段临时微调，主办方深夜发文说明",
    summary: "官方给出一句简短解释后，评论区迅速分成好几派各说各话。",
    tag: "官方回应",
    heat: "64.7万",
    comments: "1,988",
  },
  {
    rank: 5,
    title: "短剧演员密集官宣新合作，平台排播节奏出现变化",
    summary: "一周之内接连三次官宣，外界开始猜测档期是否有意错开。",
    tag: "合作动向",
    heat: "52.3万",
    comments: "1,466",
  },
  {
    rank: 6,
    title: "老牌乐队巡回官宣，首站门票开售三分钟告罄",
    summary: "加场呼声持续走高，票务页面一度被挤到刷新缓慢。",
    tag: "现场热榜",
    heat: "47.9万",
    comments: "1,201",
  },
  {
    rank: 7,
    title: "电影路演临时加场，主创行程被细心的网友扒了个遍",
    summary: "官方行程表与现场实际路线出现出入，讨论热度顺势上升。",
    tag: "行程观察",
    heat: "39.5万",
    comments: "946",
  },
  {
    rank: 8,
    title: "电竞战队转会期连环操作，粉丝超话连夜更换头像",
    summary: "一条简短的官宣动态，让整个超话的讨论节奏瞬间提速。",
    tag: "转会窗口",
    heat: "31.8万",
    comments: "782",
  },
];

export type HotComment = {
  user: string;
  initial: string;
  tone: string;
  time: string;
  text: string;
  likes: number;
  replies: number;
  pinned?: boolean;
};

export const hotComments: HotComment[] = [
  {
    user: "瓜田里的猫",
    initial: "瓜",
    tone: "primary",
    time: "12 分钟前",
    text: "先别急着下结论，等一个完整版现场视频再聊，现在看到的都是碎片。",
    likes: 3421,
    replies: 268,
    pinned: true,
  },
  {
    user: "理性围观选手",
    initial: "理",
    tone: "secondary",
    time: "38 分钟前",
    text: "这波节奏起得有点快，热帖前三条几乎都是同一个话题，感觉还没到定论的时候。",
    likes: 1876,
    replies: 143,
  },
  {
    user: "深夜刷帖党",
    initial: "夜",
    tone: "accent",
    time: "1 小时前",
    text: "就喜欢这种标题加短摘要的排版，扫一眼就知道值不值得点进去看详情。",
    likes: 1204,
    replies: 96,
  },
  {
    user: "只吃真瓜",
    initial: "真",
    tone: "primary",
    time: "2 小时前",
    text: "排行更新得是真快，早上看还在第六位，中午已经冲到第二了。",
    likes: 986,
    replies: 74,
  },
  {
    user: "评论区常驻",
    initial: "评",
    tone: "secondary",
    time: "3 小时前",
    text: "热度高不代表内容全对，还是那句话，吃瓜图个乐，别上头。",
    likes: 812,
    replies: 58,
  },
  {
    user: "追更达人",
    initial: "追",
    tone: "accent",
    time: "4 小时前",
    text: "建议把话题入口做成一排标签，找自己想看的那一类特别方便。",
    likes: 653,
    replies: 41,
  },
];

export const topicEntries = [
  { name: "演唱会现场", count: "1,284 帖", icon: "ri-mic-line" },
  { name: "影视路透", count: "968 帖", icon: "ri-clapperboard-line" },
  { name: "综艺风向", count: "742 帖", icon: "ri-tv-2-line" },
  { name: "音乐节热榜", count: "613 帖", icon: "ri-music-2-line" },
  { name: "短剧动向", count: "508 帖", icon: "ri-film-line" },
  { name: "电竞转会", count: "436 帖", icon: "ri-gamepad-line" },
  { name: "官宣合集", count: "327 帖", icon: "ri-megaphone-line" },
  { name: "热评精选", count: "265 帖", icon: "ri-chat-smile-2-line" },
];

export const navLinks = [
  { label: "首页", href: "#top" },
  { label: "热帖排行", href: "#ranking" },
  { label: "吃瓜现场", href: "#comments" },
  { label: "话题入口", href: "#topics" },
  { label: "吃瓜速递", href: "#subscribe" },
];